import React, { memo } from 'react'
import { ArrowLeftIcon } from '../../assets/icons/ArrowLeftIcon'
import { ArrowRightIcon } from '../../assets/icons/ArrowRightIcon'
import IconButton from '../iconButton/IconButton'
import './ElementPaginator.scss'
const rootClassName = 'element-paginator'

interface ElementPaginatorProps {
  atual: number
  size: number
  onChange: (newAtual: number) => void
  infinite?: boolean
  hideArrows?: boolean
}

function ElementPaginator(props: ElementPaginatorProps) {
  const handleChange = (num: number) => {
    if (num > props.size) {
      props.onChange(1)
    } else if (num <= 0) {
      props.onChange(props.size)
    } else {
      props.onChange(num)
    }
  }

  return (
    <div className={rootClassName}>
      {props.hideArrows ? undefined : (
        <div>
          <IconButton
            className={`${rootClassName}-buttons`}
            icon={<ArrowLeftIcon />}
            onClick={() => handleChange(props.atual - 1)}
            disabled={!props.infinite && props.atual === 1}
          />
        </div>
      )}
      <div className={`${rootClassName}-indexes`}>
        {Array.from({ length: props.size }).map((_, i) => {
          return (
            <div
              key={i}
              className={props.atual === i + 1 ? 'atual' : ''}
              onClick={() => {
                handleChange(i + 1)
              }}
            >
              <span />
            </div>
          )
        })}
      </div>
      {props.hideArrows ? undefined : (
        <div>
          <IconButton
            className={`${rootClassName}-buttons`}
            icon={<ArrowRightIcon />}
            onClick={() => handleChange(props.atual + 1)}
            disabled={!props.infinite && props.atual === props.size}
          />
        </div>
      )}
    </div>
  )
}

ElementPaginator.defaultProps = {
  infinite: true
}
export default memo(ElementPaginator)
